import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../redux/slices/uiSlice";

/**
 * Shared dark/light mode reader — every page's color-constant object should
 * pick its LIGHT or DARK variant based on `mode`, and `dispatch(toggleTheme())`
 * is what the profile-menu toggle calls to flip it globally.
 */
export default function useThemeMode() {
  const mode = useSelector((s) => (s.ui ? s.ui.mode : undefined));   // a store without the ui slice (a small test store) reads as light
  const dispatch = useDispatch();
  const isDark = mode === "dark";
  return { mode, isDark, toggleTheme: () => dispatch(toggleTheme()) };
}
